import {Scanner} from "@yudiel/react-qr-scanner";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../../modules/commons/Button";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import * as R from "ramda";
import {ACTIVITY_TYPE} from "../../../../common/Constants";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { TABS } from "../../config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class MutasiBarangDetailTabKSU extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) =>
                    <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {rowIndex + 1}
                    </p>,
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "kodeKsu",
            label: "Kode KSU",
            options: {
                customHeadRender: (props) => (
                    <th key={props.index} className="custom-locator padding-right-15px">
                        <p style={{display: "flex"}}>
                            <>Kode KSU<span style={{color: "red"}}>*</span></>
                        </p>
                    </th>
                ),
                customBodyRender: (val, {rowIndex}) => (
                    <>
                        {this.props.mutasiKeluarTab ? (
                            <SimpleDDL
                                id="select_options_kode_ksu"
                                name="kodeKsu"
                                box="search"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        position: "relative",
                                        fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                containerclassname="margin-bottom-none"
                                readOnly={this.props.state.data.mutationKsus[rowIndex].saved}
                                options={this.props.state.kodeKSUOptions}
                                value={val}
                                onChange={(value, {name}) => this.handleValueChange(rowIndex, name, value)}
                            />
                        ) : (
                            <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val.label}
                            </p>
                        )}
                    </>
                ),
                setCellProps: () => ({
                    style: {width: `${this.props.mutasiKeluarTab ? "200px" : "auto"}`},
                }),
            },
        },
        {
            name: "nameKsu",
            label: "Nama KSU",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                )
            }
        },
        {
            name: "categoryKsu",
            label: "Kategori",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                )
            }
        },
        {
            name: "qty",
            label: "Qty",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                )
            }
        },
        {
            name: "satuan",
            label: "Satuan",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                )
            }
        },
        {
            name: "ksuBarcode",
            label: "QR Code",
            options: {
                customHeadRender: (props) => (
                    <th key={props.index} className="custom-locator padding-right-15px">
                        <p style={{display: "flex"}}>
                            <>QR Code<span style={{color: "red"}}>*</span></>
                        </p>
                    </th>
                ),
                customBodyRender: (val, {rowIndex}) => (
                    <>
                        {this.props.mutasiKeluarTab ? (
                                <SimpleInput
                                    id="input_text_qrcode"
                                    name="ksuBarcode"
                                    readOnly={this.props.state.data.mutationKsus[rowIndex].saved}
                                    value={val}
                                    containerclassname={"margin-bottom-none " + this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}
                                    onChange={({target}) => this.handleValueChange(rowIndex, target.name, target.value)}
                                />
                            ) :
                            <p className={this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        }
                    </>
                ),
                setCellProps: () => ({
                    style: {width: "250px"},
                }),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.tableColumns.push({
            name: `${this.props.mutasiKeluarTab ? "saved" : "status"}`,
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {return this.addKSUDetailButton(val, rowIndex)},
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        });
        this.state = {
            scannerVisible: false,
            noLocator: false,
            noBarcodeDetected: false,
            noKsuCode: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    handleChecked = (rowIndex) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationKsus: prevValue.data.mutationKsus.map((u, idx) =>
                    idx === rowIndex
                        ? {
                            ...u,
                            status: "RECEIVED",
                            checked: !u.checked,
                        }
                        : u
                ),
            },
        }));
    };

    handleValueChange = (index, name, value) => {
        if(name === 'ksuBarcode' && !this.props.state.data.mutationKsus[index].kodeKsu){
            this.handleTriggerNoKSUCode()
            return
        }
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationKsus: prevValue.data.mutationKsus.map((u, idx) =>
                    idx === index
                        ? {
                            ...u,
                            [name]: value,
                            ...(name === "kodeKsu"
                                ? {nameKsu: value.name, categoryKsu: value.category, satuan: value.satuan}
                                : {}),
                        }
                        : u
                ),
            },
        }));
    };

    handleAddKSU = () => {
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            const newRow = {
                kodeKsu: null,
                nameKsu: "",
                categoryKsu: "",
                qty: 1,
                ksuBarcode: "",
                satuan: "",
                saved: false,
            };
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    mutationKsus: [...prevValue.data.mutationKsus, newRow],
                },
            }));
        } else {
            this.handleTriggerNoLocator();
        }
    };

    validateInputBarcode = async (index) =>{
       try {
         const request = {
            nameCategory: "KSU",
            encryptBarcode: null,
            barcode: this.props.state.data.mutationKsus[index]?.ksuBarcode,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang?.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator?.value,
            "codeItem" : this.props.state.data.mutationKsus[index]?.kodeKsu?.value,
            trxType: this.props.mutasiKeluarTab ?"TRX_IN" : "TRX_OUT"
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").findBarcodeKsuBrlHdhMutation(request);
        console.log(response)
        if(response.ok && response.data.data!==null){
            return 'Barcode Ditemukan'
        }
        return null
       } catch (error) {
        return null
       }
    }

    handleSaveRow = async (index) => {
        const validateResult = await this.validateInputBarcode(index)
        console.log(validateResult,'aw')
        if(validateResult===null){
            this.handleTriggerNoBarcodeDetected()
            return
        }
        this.props.onSetState((prevValue) => {
            const newState = [...prevValue.data.mutationKsus];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            if (!this.validDetail(newState[index])) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Ada field data yang perlu diisi atau tidak sesuai kriteria isian. Mohon periksa kembali.",
                }
            }

            let duplicate = newState.filter(item => item.ksuBarcode === newState[index].ksuBarcode && item.saved === true);
            if (duplicate.length > 1) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Barcode yang anda masukan sudah ada. Mohon periksa kembali.",
                }
            }

            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    mutationKsus: newState,
                },
            };
        });
    };

    validDetail = (obj) => {
        const column = ["kodeKsu", "ksuBarcode"];
        for (const [key, data] of Object.entries(obj)) {
            if (column.includes(key) && R.or(R.isNil(data), !data, R.isEmpty(data))){
                return false;
            }
        }

        return true;
    }

    handleDeleteRow = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationKsus: prevValue.data.mutationKsus.filter((_, idx) => idx !== index),
            },
        }));
    };

    handleReject = (rowIndex) => {
        let obj = this.props.state.data.mutationKsus.filter((a, idx) => {
            if (idx === rowIndex) {
                a.status = a.status !== "REJECTED" ? "REJECTED" : a.scanned ? "SCANNED" : null;
            }
            return a;
        });
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationKsus: obj,
            },
        }));
    }

    handleShowScanner = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            scannerVisible: !prevValue.scannerVisible,
        }));
    };

    handleScanQR = async (data) => {
        const request = {
            nameCategory: "KSU",
            encryptBarcode: data[0].rawValue,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang?.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator?.value,
            trxType: this.props.mutasiKeluarTab ?"TRX_IN" : "TRX_OUT"
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").findBarcodeKsuBrlHdhMutation(request);
        console.log("response: ", response);
        if (response.ok && !R.isNil(response.data.data) && !R.isEmpty(response.data.data)) {
            const data = response.data.data;
            const isAlreadyExist = this.props?.state?.data?.mutationKsus?.find(item => item.saved && item?.ksuBarcode === data.barcode)
            
            if(this.props.mutasiKeluarTab && isAlreadyExist){
                this.props.onSetState((prev) => ({
                    ...prev,
                    alertVisible: !prev.alertVisible,
                    warningMessage: "Item yang anda pilih sudah ada. Mohon periksa kembali.",
                }))
                this.handleShowScanner();
                return
            }

            if (this.props.state.data.mutationSourceKodeLocator?.value === data.kodeLocator) {
                let obj;
                if (this.props.mutasiKeluarTab) {
                    const ksuValue = this.props.state.kodeKSUOptions.find((kv) =>
                        R.equals(kv.value, data.kodeItem)
                    );
                    obj = {
                        kodeKsu: ksuValue ? {...ksuValue} : null,
                        ksuBarcode: data.barcode,
                        nameKsu: ksuValue ? ksuValue.name : "",
                        categoryKsu: ksuValue ? ksuValue.category : "",
                        satuan: ksuValue ? ksuValue.satuan : "",
                        qty: 1,
                        saved: true,
                        scanned: false,
                        status: "ONPROGRESS",
                    };
                } else {
                    obj = this.props.state.data.mutationKsus.filter((a, idx) => {
                        if (a.ksuBarcode === data.barcode) {
                            a.scanned = true;
                            a.checked = true;
                            a.status = "RECEIVED";
                        }
                        return a;
                    });
                }
                const mutationKsus = this.props.mutasiKeluarTab ? [...this.props.state.data.mutationKsus, obj] : obj
                this.props.onSetState((prevValue) => ({
                    ...prevValue,
                    data: {
                        ...prevValue.data,
                        mutationKsus: mutationKsus,
                    },
                }));
            }

        }
        this.handleShowScanner();
    };

    addUnitButton = () => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <SimpleButton
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            text="Tambah"
                            secondary={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            onClick={this.handleAddKSU}
                        />
                    </>
                )
            }
        }
    }

    addKSUDetailButton = (val, rowIndex) => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleSaveRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                    <span
                                        style={{
                                            backgroundColor: "transparent",
                                            color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                            fontSize: 20,
                                        }}
                                    >
                                      {!val ? <i className="fa fa-save"/> : <i className="fa fa-lw fa-pencil-alt"/>}
                                    </span>
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleDeleteRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    </>
                )
            } else {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data.mutationKsus[rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                        </FlexView>
                    </>
                )
            }
        } else {
            if (this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.data.mutationStatus === "REJECT_APPROVE" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data.mutationKsus[rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleReject(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <span style={{ position: 'relative', fontSize: 20, display: 'inline-block' }}>
                                    <i
                                      className="fas fa-hand-paper"
                                      style={{
                                        color:
                                          this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                            ? "black"
                                            : "red",
                                      }}
                                    />
                                    <i
                                      className="fas fa-slash"
                                      style={{
                                        position: 'absolute',
                                        top: 2.5,
                                        left: 0,
                                        color:
                                          this.props.state.data.mutationKsus[rowIndex].status === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                            ? "black"
                                            : "red",
                                      }}
                                    />
                                </span>
                            </Button>
                        </FlexView>
                    </>
                )
            }
        }
    }

    handleTriggerNoLocator = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noLocator: !prevValue.noLocator
        }))
    }

    handleTriggerNoBarcodeDetected = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noBarcodeDetected: !prevValue.noBarcodeDetected
        }))
    }
    
    handleTriggerNoKSUCode = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noKsuCode: !prevValue.noKsuCode
        }))
    }

    addUnitViaScanner = () =>{
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            this.handleShowScanner()
        }else{
            this.handleTriggerNoLocator();
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                    <h4>KSU:</h4>
                    {this.addUnitButton()}
                    <Button
                        type="button"
                        className="btn"
                        style={{borderRadius: "50%"}}
                        disabled={
                            this.props.mutasiKeluarTab ?
                                !(this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview" :
                                !(this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.data.mutationStatus === "REJECT_APPROVE" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                        }
                        onClick={()=>this.addUnitViaScanner()}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                {this.state.noLocator && (
                    <SimpleModal
                        title={"No Locator Detected"}
                        styles={{width: "40%"}}
                        visible={this.state.noLocator}
                        onClickClose={this.handleTriggerNoLocator}
                        content={"No Locator Detected"}
                    />
                )}
                {this.state.noBarcodeDetected && (
                    <SimpleModal
                        title={"No Barcode Detected"}
                        styles={{width: "40%"}}
                        visible={this.state.noBarcodeDetected}
                        onClickClose={this.handleTriggerNoBarcodeDetected}
                        content={"No Barcode Detected"}
                    />
                )}
                {this.state.noKsuCode && (
                    <SimpleModal
                        title={"No KSU Code Detected"}
                        styles={{width: "40%"}}
                        visible={this.state.noKsuCode}
                        onClickClose={this.handleTriggerNoKSUCode}
                        content={"No KSU Code Detected"}
                    />
                )}
                <SimpleDataTable
                    key={`${this.props.state.data.mutationKsus?.length}-${this.state.pagination.page}`}
                    data={this.props.state.data.mutationKsus}
                    columns={this.tableColumns}
                    toCount={this.props.state.data.mutationKsus?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
                {this.state.scannerVisible && (
                    <SimpleModal
                        title={"Scan QR Here"}
                        styles={{width: "40%"}}
                        visible={this.state.scannerVisible}
                        onClickClose={this.handleShowScanner}
                        content={
                            <Scanner
                                onScan={this.handleScanQR}
                                constraints={{
                                    height: {ideal: 720},
                                    video: {
                                        facingMode: { exact: "environment" },
                                        height: { ideal: 720 }
                                    },
                                }}
                            />
                        }
                    />
                )}
            </>
        );
    }
}

export default MutasiBarangDetailTabKSU;
